/**
 * De keuzegalerij voor het portret van een persona: de basisset uit
 * backend/portretten/ plus wat eerder is geüpload, en een veld om een eigen
 * portret te uploaden.
 */
import React, { useState } from 'react';
import { kleur } from '../../../theme/tokens';
import { portretUrl } from '../../../components/Portret';
import { basis } from '../stijlen';

export function PortretKiezer({ api, apiUrl, portretten, huidig, onKies, onGeupload }) {
  const [fout, setFout] = useState('');

  const upload = async (bestand) => {
    if (!bestand) return;
    setFout('');
    try {
      const data = await api.uploadPortret(bestand);
      if (data.success) {
        onKies(data.data.portret);
        onGeupload();
      } else {
        setFout(data.detail || 'Het uploaden is niet gelukt.');
      }
    } catch (err) {
      setFout('Het uploaden is niet gelukt.');
    }
  };

  return (
    <div style={styles.portretBlok}>
      <label style={styles.label}>Portret (zien de leerlingen)</label>
      <div style={styles.portretGalerij}>
        <button type="button" onClick={() => onKies('')}
          style={!huidig ? styles.portretLeegActief : styles.portretLeeg} title="Geen portret">
          geen
        </button>
        {[...portretten.basis, ...portretten.uploads].map(naam => (
          <button key={naam} type="button" onClick={() => onKies(naam)}
            style={huidig === naam ? styles.portretKeuzeActief : styles.portretKeuze} title={naam}>
            <img src={portretUrl(apiUrl, naam)} alt={naam} style={styles.portretMini} />
          </button>
        ))}
      </div>
      <label style={styles.portretUploadLabel}>
        Eigen portret uploaden (PNG, JPG of WEBP, max 2 MB)
        <input type="file" accept=".png,.jpg,.jpeg,.webp"
          onChange={(e) => { upload(e.target.files[0]); e.target.value = ''; }}
          style={styles.input} />
      </label>
      {fout && <p style={styles.portretFout}>{fout}</p>}
      {portretten.basis.length === 0 && (
        <p style={styles.beschrijving}>
          De basisset is nog leeg. Zet de bestanden in <code>backend/portretten/</code> en rol de code uit.
        </p>
      )}
    </div>
  );
}

const rond = { padding: 0, width: '56px', height: '56px', borderRadius: '50%', background: 'white', cursor: 'pointer', overflow: 'hidden' };

const styles = {
  ...basis,
  portretBlok: { border: `1px solid ${kleur.lijn}`, borderRadius: '10px', padding: '12px', marginBottom: '12px', background: kleur.vlakWarm },
  portretGalerij: { display: 'flex', flexWrap: 'wrap', gap: '8px', margin: '8px 0 12px' },
  portretKeuze: { ...rond, border: `2px solid ${kleur.lijn}` },
  portretKeuzeActief: { ...rond, border: `3px solid ${kleur.accent}` },
  portretMini: { width: '100%', height: '100%', objectFit: 'cover', display: 'block' },
  portretLeeg: { width: '56px', height: '56px', borderRadius: '50%', border: `2px dashed ${kleur.lijnStippel}`, background: 'white', cursor: 'pointer', fontSize: '12px', color: kleur.grijs },
  portretLeegActief: { width: '56px', height: '56px', borderRadius: '50%', border: `3px solid ${kleur.accent}`, background: 'white', cursor: 'pointer', fontSize: '12px', color: kleur.tekst },
  portretUploadLabel: { display: 'block', fontSize: '13px', color: kleur.tekstZacht },
  portretFout: { color: kleur.roodDonker, fontSize: '13px', margin: '8px 0 0' },
};
